<page-title text="Signup | BitOasis" i18n-text="@@pageTitle.register"></page-title>
<site-layout class="narrow push">
  <loading class="full" *ngIf="loading">Loading data</loading>

  <ng-container *ngIf="!loading">
    <ng-container *ngIf="verifyAndEarnPromotion?.promotionEnabled && !inviteAndEarnPromotion?.firstName">
      <h2 class="text-header text-bold text-center text-dark mb-2" i18n="@@front.register.verifyAndEarn.title">Here’s {{verifyAndEarnPromotion?.reward?.currency}} {{verifyAndEarnPromotion?.reward?.amount}} on us</h2>
      <p class="text-lg text-center" i18n="@@front.register.verifyAndEarn.subtitle">Jumpstart your crypto journey today</p>
    </ng-container>

    <ng-container *ngIf="verifyAndEarnPromotion?.promotionEnabled && inviteAndEarnPromotion?.firstName">
      <h2 class="text-header text-bold text-center text-dark mb-2" i18n="@@front.register.verifyAndEarnWithRefferal.title">Rewards... Rewards everywhere!</h2>
      <p class="text-lg text-center" i18n="@@front.register.verifyAndEarnWithRefferal.subtitle">Get {{verifyAndEarnPromotion?.reward?.currency}} {{verifyAndEarnPromotion?.reward?.amount}} reward when you sign up and verify, with up to AED/SAR 500 referral bonus</p>
    </ng-container>

    <ng-container *ngIf="!verifyAndEarnPromotion?.promotionEnabled">
      <h2 class="text-header text-bold text-center text-dark mb-2" i18n="@@front.register.title">Get Started</h2>
      <p class="text-lg text-center" i18n="@@front.register.subtitle">Create an account</p>
    </ng-container>

    <div *ngIf="inviteAndEarnPromotion?.firstName" class="text-sm text-center" i18n="@@front.register.verifyAndEarnWithRefferal.refferalName">You have been invited by {{inviteAndEarnPromotion?.firstName}}</div>
  </ng-container>

  <div class="p-3"></div>

  <auth-register [referralId]="referralId"></auth-register>

  <div *ngIf="error" class="p-3 text-gray text-center">{{error}}</div>

</site-layout>
<site-footer></site-footer>